<div class="main">
        <div class="header">
          {{'ACCESSORIES.accessory' | translate}}
          <i class='material-icons'(click)="closeDialog();">clear</i>
        </div>
        <div class="section">
          <div class="form">
            <div class="input">
              {{'ACCESSORIES.name' | translate}} <input type="text" class="form-input" [(ngModel)]="accessory.name" />
            </div>
          </div>
          <div class="submitButton">
            <div class="button" (click)="addAccessory();">
              {{'ACCESSORIES.submit' | translate}}
            </div>
          </div>
        </div>
      </div>
      